import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCog,
  faFileAlt,
  faCoins,
  faWrench,
  faTimes,
  faChartLine,
  faUsers,
  faClipboardList
} from '@fortawesome/free-solid-svg-icons';
import logo from '../../assets/icons/logo.png';

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

  const navItems = [
    { path: '/dashboard', icon: faChartLine, label: 'Dashboard' },
    { path: '/coins', icon: faCoins, label: 'Coins' },
    { path: '/coin-users', icon: faUsers, label: 'Users' },
    { path: '/coin-config', icon: faWrench, label: 'Coin Config' },
    { path: '/coin-tasks', icon: faClipboardList, label: 'Task Manager' },
    { path: '/logs', icon: faFileAlt, label: 'Error Logs' }
  ];
  const settingsItems = [
    { path: '/settings', icon: faCog, label: 'Settings' }
  ];

  const handleLinkClick = () => {
    if (window.innerWidth < 992 && onClose) {
      onClose();
    }
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}

      <aside className={`menu ${isOpen ? 'show' : ''}`}>
        <div className="menu-inner">
          <div className="menu-header d-lg-none">
            <h1 className="navbar-brand navbar-brand-autodark mb-0">
              <Link to="/dashboard" className="d-flex align-items-center ps-2" onClick={handleLinkClick}>
                <img src={logo} alt="Coin Dashboard Logo" style={{ height: '32px', marginRight: '10px' }} />
                Coin Dashboard
              </Link>
            </h1>
            <button
              className="btn btn-link text-secondary p-0"
              type="button"
              onClick={onClose}
              aria-label="Close menu"
            >
              <FontAwesomeIcon icon={faTimes} size="lg" />
            </button>
          </div>

          <h1 className="navbar-brand navbar-brand-autodark d-none d-lg-block">
            <Link to="/dashboard" className="d-flex align-items-center ps-2">
              <img src={logo} alt="Coin Dashboard Logo" style={{ height: '32px', marginRight: '10px' }} />
              Coin Dashboard
            </Link>
          </h1>

          <nav className="menu-nav" id="navbar-menu" aria-label="Main">
            <ul className="menu-nav-list pt-lg-3">
              {navItems.map((item) => (
                <li className="nav-item" key={item.path}>
                  <Link
                    to={item.path}
                    className={`nav-link ${
                      location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path + '/'))
                        ? 'active'
                        : ''
                    }`}
                    onClick={handleLinkClick}
                  >
                    <FontAwesomeIcon icon={item.icon} className="nav-link-icon" />
                    <span className="nav-link-title">{item.label}</span>
                  </Link>
                </li>
              ))}
              {settingsItems.map((item) => (
                <li className="nav-item" key={item.path}>
                  <Link
                    to={item.path}
                    className={`nav-link ${location.pathname === item.path ? 'active' : ''}`}
                    onClick={handleLinkClick}
                  >
                    <FontAwesomeIcon icon={item.icon} className="nav-link-icon" />
                    <span className="nav-link-title">{item.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </aside>
    </>
  );
};

export default Sidebar;
